export default {
  TITLE: 'Sucesso!',
  BUTTON_CONTINUE: 'Continuar entregando'
};
